import React, {ReactNode} from 'react';

import {IFieldTooltipMetadata, EFieldTooltipType} from 'entities/metadata/tooltip-metadata-types';

import {TooltipAsStringStructure} from './tooltip-content/tooltip-as-string-structure/tooltip-as-string-structure';
import {CurrentUserInfoTooltip} from './tooltip-content/tooltip-current-user-info/tooltip-current-user-info';
import {TooltipList} from './tooltip-content/tooltip-list/tooltip-list';

export const tooltipTypeResolver = (meta: IFieldTooltipMetadata): ReactNode => {
    switch (meta.type) {
    case EFieldTooltipType.LIST:
        return (
            <TooltipList
                entityName={meta.contentEntityName}
                url={meta.requestUrl}
            />
        );

    case EFieldTooltipType.DYNAMIC_STRING:
        return (
            <TooltipAsStringStructure
                {...meta}
            />
        );

    case EFieldTooltipType.CURRENT_USER_INFO_LIST:
        return <CurrentUserInfoTooltip entityName={meta.contentEntityName} />;
    default:
        return meta.contentStructure;
    }
};
